import { Outlet, createFileRoute } from "@tanstack/react-router";
import { BookOpen01 } from "@untitled-ui/icons-react";

import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import type { ChildRouteContext } from "@/root";
import { redirectIfModuleDisabled } from "@/utils/permissions";

export const Route = createFileRoute("/admin/_panel/_handbook")({
  component: Component,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("handbook", context.tenant.modules);

    return {
      title: () => context.t("Handbook", { ns: "handbook.shared" }),
      crumb: [
        {
          Icon: BookOpen01,
        },
      ],
    } satisfies ChildRouteContext;
  },
  pendingComponent: TableSkeleton,
});

function Component() {
  return <Outlet />;
}
